import { useState } from "react";
import { PageTitle, Table, useList } from "@/pages/admin/ui";

const TABS = [
  { key: "event", label: "Event Catering", path: "/admin/enquiries/event", cols: ["name", "company", "phone", "enquiry_category", "event_type", "event_date", "city", "guest_count"] },
  { key: "bulk", label: "Bulk & Food Service", path: "/admin/enquiries/bulk", cols: ["name", "company", "phone", "service_type", "frequency", "meals_count", "location"] },
  { key: "contact", label: "General Contact", path: "/admin/enquiries/contact", cols: ["name", "organisation", "phone", "email", "requirement_type"] },
];

export default function Enquiries() {
  const [tab, setTab] = useState(TABS[0]);
  const { data, loading } = useList(tab.path, [tab.path]);

  return (
    <div data-testid="admin-enquiries">
      <PageTitle title="Enquiries" subtitle="All incoming leads across event, bulk and general pipelines — kept separate." />
      <div className="mb-5 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t)} data-testid={`enquiries-tab-${t.key}`}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${tab.key === t.key ? "bg-[#2C201A] text-white" : "border border-[#E2E8F0] text-[#64748B] hover:bg-white"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {loading ? <div className="text-sm text-[#64748B]">Loading…</div> : (
        <Table headers={[...tab.cols.map((c) => c.replace(/_/g, " ")), "email", "received"]}>
          {data.map((r) => (
            <tr key={r.id} className="hover:bg-[#F8F9FA]">
              {tab.cols.map((c) => <td key={c} className="px-4 py-3 capitalize text-[#334155]">{r[c] || "—"}</td>)}
              <td className="px-4 py-3 text-[#334155]">{r.email}</td>
              <td className="px-4 py-3 text-xs text-[#94A3B8]">{(r.created_at || "").slice(0, 10)}</td>
            </tr>
          ))}
          {data.length === 0 && <tr><td colSpan={tab.cols.length + 2} className="px-4 py-10 text-center text-[#94A3B8]">No enquiries yet.</td></tr>}
        </Table>
      )}
    </div>
  );
}
